// extracted by mini-css-extract-plugin
export default {"groupTitle":"styles_groupTitle__XohXT","text":"styles_text__DFcaz"};